import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './styles.css'

class Box extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    shadow: PropTypes.bool,
    hidden: PropTypes.bool,
  }

  static defaultProps = {
    className: '',
    shadow: false,
    hidden: false,
  }

  getClassName() {
    return classnames(
      styles.root,
      { [styles.shadow]: this.props.shadow },
      { [styles.hidden]: this.props.hidden },
      this.props.className,
    )
  }

  render() {
    const { children, shadow, ...restProps } = this.props

    return (
      <div {...restProps} className={this.getClassName()}>
        {this.props.children}
      </div>
    )
  }
}

const BoxSection = ({
  className,
  children,
  disabled,
  disabledContent,
  ...restProps
}) => (
  <div {...restProps} className={classnames(styles.section, className)}>
    {children}
    {disabled && (
      <div className={styles.disabledOverlay}>{disabledContent}</div>
    )}
  </div>
)

BoxSection.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  disabledContent: PropTypes.element,
}

BoxSection.defaultProps = {
  className: '',
  disabled: false,
  disabledContent: null,
}

export default Box
export { BoxSection }



// WEBPACK FOOTER //
// ../source/layouts/Box/index.js